import { useTranslation } from "react-i18next";
import { PLATFORM_STATS, getPlatformStatI18nLabels } from "./platformStats";

export type FaqCategoriesType = { name: string; slug: string }[];

export enum FaqSlugsConstant {
    GENERAL = "general",
    BOOKING_TRUCKS = "booking-trucks",
    BOOKING_LOADS = "booking-loads",
    GROWING_NETWORKS = "grow-networks",
    FRAUD_PREVENTION = "fraud-prevention",
    LOGISTICS_SERVICES = "logistics-services"
}

export const FaqCategories: FaqCategoriesType = [
    { name: "General FAQ’s", slug: FaqSlugsConstant.GENERAL },
    { name: "Booking Trucks", slug: FaqSlugsConstant.BOOKING_TRUCKS },
    { name: "Booking Loads", slug: FaqSlugsConstant.BOOKING_LOADS },
    { name: "Grow Network", slug: FaqSlugsConstant.GROWING_NETWORKS },
    { name: "Fraud Prevention", slug: FaqSlugsConstant.FRAUD_PREVENTION },
    { name: "Logistics Services", slug: FaqSlugsConstant.LOGISTICS_SERVICES }
];

export const useFaqCategories = () => {
    const { t } = useTranslation("faq");
    const FaqCategories: FaqCategoriesType = [
        { name: t("faq:General_FAQ"), slug: FaqSlugsConstant.GENERAL },
        { name: t("faq:booking_trucks"), slug: FaqSlugsConstant.BOOKING_TRUCKS },
        { name: t("faq:booking_loads"), slug: FaqSlugsConstant.BOOKING_LOADS },
        { name: t("faq:grow_network"), slug: FaqSlugsConstant.GROWING_NETWORKS },
        { name: t("faq:fraud_prevention"), slug: FaqSlugsConstant.FRAUD_PREVENTION },
        { name: t("faq:logistics_services"), slug: FaqSlugsConstant.LOGISTICS_SERVICES }
    ];
    return FaqCategories;
};
export const useFaqQuestions = (t: Function) => {
    const FaqQuestions = [
        {
            category: FaqSlugsConstant.GENERAL,
            faqQuestions: [
                {
                    question: t("faq:general.question1.question"),
                    response: t("faq:general.question1.response"),
                    subContent: [
                        t("faq:general.question1.subcontent.point1"),
                        t("faq:general.question1.subcontent.point2"),
                        t("faq:general.question1.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:general.question2.question"),
                    response: t("faq:general.question2.response"),
                    link: "https://6r7cz.app.link/generalfaq2"
                },
                {
                    question: t("faq:general.question3.question"),
                    response: t("faq:general.question3.response"),
                    subContent: [
                        t("faq:general.question3.subcontent.point1"),
                        t("faq:general.question3.subcontent.point2"),
                        t("faq:general.question3.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:general.question4.question"),
                    response: t("faq:general.question4.response")
                },
                {
                    question: t("faq:general.question5.question"),
                    response: t("faq:general.question5.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.BOOKING_TRUCKS,
            faqQuestions: [
                {
                    question: t("faq:booking-trucks.question1.question"),
                    subContent: [
                        t("faq:booking-trucks.question1.subcontent.point1"),
                        t("faq:booking-trucks.question1.subcontent.point2"),
                        t("faq:booking-trucks.question1.subcontent.point3"),
                        t("faq:booking-trucks.question1.subcontent.point4"),
                        t("faq:booking-trucks.question1.subcontent.point5")
                    ]
                },
                {
                    question: t("faq:booking-trucks.question2.question"),
                    response: t("faq:booking-trucks.question2.response", getPlatformStatI18nLabels()),
                    subContent: [
                        t("faq:booking-trucks.question2.subcontent.point1"),
                        t("faq:booking-trucks.question2.subcontent.point2"),
                        t("faq:booking-trucks.question2.subcontent.point3"),
                        t("faq:booking-trucks.question2.subcontent.point4"),
                        t("faq:booking-trucks.question2.subcontent.point5")
                    ]
                },
                {
                    question: t("faq:booking-trucks.question3.question"),
                    response: t("faq:booking-trucks.question3.response")
                },
                {
                    question: t("faq:booking-trucks.question4.question"),
                    response: t("faq:booking-trucks.question4.response")
                },
                {
                    question: t("faq:booking-trucks.question5.question"),
                    response: t("faq:booking-trucks.question5.response")
                },
                {
                    question: t("faq:booking-trucks.question6.question"),
                    response: t("faq:booking-trucks.question6.response")
                },
                {
                    question: t("faq:booking-trucks.question7.question"),
                    response: t("faq:booking-trucks.question7.response")
                },
                {
                    question: t("faq:booking-trucks.question8.question"),
                    response: t("faq:booking-trucks.question8.response")
                },
                {
                    question: t("faq:booking-trucks.question9.question"),
                    response: t("faq:booking-trucks.question9.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.BOOKING_LOADS,
            faqQuestions: [
                {
                    question: t("faq:booking-loads.question1.question"),
                    subContent: [
                        t("faq:booking-loads.question1.subcontent.point1"),
                        t("faq:booking-loads.question1.subcontent.point2"),
                        t("faq:booking-loads.question1.subcontent.point3"),
                        t("faq:booking-loads.question1.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:booking-loads.question2.question"),
                    response: t("faq:booking-loads.question2.response", getPlatformStatI18nLabels()),
                    subContent: [
                        t("faq:booking-loads.question2.subcontent.point1"),
                        t("faq:booking-loads.question2.subcontent.point2"),
                        t("faq:booking-loads.question2.subcontent.point3"),
                        t("faq:booking-loads.question2.subcontent.point4"),
                        t("faq:booking-loads.question2.subcontent.point5"),
                        t("faq:booking-loads.question2.subcontent.point6")
                    ]
                },
                {
                    question: t("faq:booking-loads.question3.question"),
                    response: t("faq:booking-loads.question3.response")
                },
                {
                    question: t("faq:booking-loads.question4.question"),
                    response: t("faq:booking-loads.question4.response")
                },
                {
                    question: t("faq:booking-loads.question5.question"),
                    response: t("faq:booking-loads.question5.response")
                },
                {
                    question: t("faq:booking-loads.question6.question"),
                    response: t("faq:booking-loads.question6.response")
                },
                {
                    question: t("faq:booking-loads.question7.question"),
                    response: t("faq:booking-loads.question7.response", getPlatformStatI18nLabels())
                },
                {
                    question: t("faq:booking-loads.question8.question"),
                    response: t("faq:booking-loads.question8.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.GROWING_NETWORKS,
            faqQuestions: [
                {
                    question: t("faq:grow-networks.question1.question"),
                    response: t("faq:grow-networks.question1.response")
                },
                {
                    question: t("faq:grow-networks.question2.question"),
                    response: t("faq:grow-networks.question2.response")
                },
                {
                    question: t("faq:grow-networks.question3.question"),
                    response: t("faq:grow-networks.question3.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.FRAUD_PREVENTION,
            faqQuestions: [
                {
                    question: t("faq:fraud-prevention.question1.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question1.subcontent.point1"),
                        t("faq:fraud-prevention.question1.subcontent.point2"),
                        t("faq:fraud-prevention.question1.subcontent.point3"),
                        t("faq:fraud-prevention.question1.subcontent.point4"),
                        t("faq:fraud-prevention.question1.subcontent.point5"),
                        t("faq:fraud-prevention.question1.subcontent.point6"),
                        t("faq:fraud-prevention.question1.subcontent.point7")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question2.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question2.subcontent.point1"),
                        t("faq:fraud-prevention.question2.subcontent.point2"),
                        t("faq:fraud-prevention.question2.subcontent.point3"),
                        t("faq:fraud-prevention.question2.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question3.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question3.subcontent.point1"),
                        t("faq:fraud-prevention.question3.subcontent.point2"),
                        t("faq:fraud-prevention.question3.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question4.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question4.subcontent.point1"),
                        t("faq:fraud-prevention.question4.subcontent.point2"),
                        t("faq:fraud-prevention.question4.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question5.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question5.subcontent.point1"),
                        t("faq:fraud-prevention.question5.subcontent.point2"),
                        t("faq:fraud-prevention.question5.subcontent.point3"),
                        t("faq:fraud-prevention.question5.subcontent.point4")
                    ]
                }
            ]
        },
        {
            category: FaqSlugsConstant.LOGISTICS_SERVICES,
            faqQuestions: [
                {
                    question: t("faq:logistics-services.question1.question"),
                    response: t("faq:logistics-services.question1.response"),
                    subContent: [
                        t("faq:logistics-services.question1.subcontent.point1"),
                        t("faq:logistics-services.question1.subcontent.point2"),
                        t("faq:logistics-services.question1.subcontent.point3"),
                        t("faq:logistics-services.question1.subcontent.point4"),
                        t("faq:logistics-services.question1.subcontent.point5"),
                        t("faq:logistics-services.question1.subcontent.point6"),
                        t("faq:logistics-services.question1.subcontent.point7", getPlatformStatI18nLabels()),
                        t("faq:logistics-services.question1.subcontent.point8")
                    ]
                },
                {
                    question: t("faq:logistics-services.question2.question"),
                    response: t("faq:logistics-services.question2.response")
                },
                {
                    question: t("faq:logistics-services.question3.question"),
                    response: t("faq:logistics-services.question3.response"),
                    subContent: [
                        t("faq:logistics-services.question3.subcontent.point1"),
                        t("faq:logistics-services.question3.subcontent.point2"),
                        t("faq:logistics-services.question3.subcontent.point3"),
                        t("faq:logistics-services.question3.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:logistics-services.question4.question"),
                    response: t("faq:logistics-services.question4.response")
                },
                {
                    question: t("faq:logistics-services.question5.question"),
                    response: t("faq:logistics-services.question5.response")
                }
            ]
        }
    ];

    return FaqQuestions;
};

export const FaqQuestions = [
    {
        category: FaqSlugsConstant.GENERAL,
        faqQuestions: [
            {
                question: "How do I get started on the Vahak Transport Marketplace?",
                response: `Join Vahak, India’s most trusted community of Transporters, Truck owners & Consignors. Follow these simple steps to get started:`,
                subContent: [
                    `Sign-up using your mobile number & choose your role: lorry provider or load provider.`,
                    `Attach your truck(s) or post your loads to get bids within 20 minutes. Approve the bids to complete deals.`,
                    `Use the ‘Load Market’ or ‘Lorry Market’ for quick bookings.`
                ]
            },
            {
                question: "Where can I download the Vahak app?",
                response: `You can download the Vahak app for free by clicking`,
                link: "https://6r7cz.app.link/generalfaq2"
            },
            {
                question: "Who can register on Vahak? What are the charges?",
                response: `Vahak is a completely free platform to find and book loads and lorries online. Users can register & choose their role as either “Lorry Provider” or “Load Provider”.`,
                subContent: [
                    `Lorry/Truck Provider: Transporters, Transportation Service Providers, Logistic Companies, Truck & Fleet Owners, Truck Brokers.`,
                    `Load Provider: Consignors & Factory Owners, Dispatch Departments, Freight Booking & Commission Agents, Transporters, Traders & Trading agents, Small & Medium Business Owners.`,
                    `Vahak is a 100% free app made for the Indian Transport Community with business-specific features to improve your brand, grow your professional transport network and save time on daily bookings.`
                ]
            },
            {
                question: "What makes Vahak a trusted platform?",
                response:
                    "The trust gap currently present in the Indian road transport market highly limits the business potential and expansion for transporters, agents and lorry owners. Vahak is a platform for transport businesses and individuals to create a unique brand backed by user ratings, connections, document verification and user recommendations."
            },
            {
                question: "What are the benefits of ‘Connections’ on Vahak?",
                response:
                    "The transport business in India is highly network-dependent. Vahak helps users connect and develop a trusted personal network. This network of ‘Connections’ can be leveraged for business growth."
            }
        ]
    },
    {
        category: FaqSlugsConstant.BOOKING_TRUCKS,
        faqQuestions: [
            {
                question: "How do I attach my loads on Vahak?",
                subContent: [
                    "Open the Vahak App",
                    "Go to “My Loads” tab and click “Post Load”",
                    "Enter your load details and select the truck type",
                    "Finalize the payment method",
                    "Now your load will be visible to all transporters on Vahak!"
                ]
            },
            {
                question: "How do I book trucks on Vahak?",
                response: `You can post your load details and get bids automatically from ${PLATFORM_STATS.transporters.lakhs} transporters. Or you can pick a truck from the  <a href='/marketplace/lorry'> “Lorry Market”</a> tab. Follow these simple steps to find trucks:`,
                subContent: [
                    "Open the Vahak app",
                    "Go to the “Market” tab",
                    "Browse through the available live lorries",
                    "Press “Book Now” and attach your load",
                    "Enter your Bid and send it across!"
                ]
            },
            {
                question: "What is the cost of booking trucks on Vahak?",
                response:
                    "Vahak is completely free! There are no commissions, brokerage fees or hidden costs. It is India’s first fully free road transport marketplace that lets users search lorries and loads online."
            },
            {
                question: "Can I track my booking status?",
                response:
                    "Yes, you can track your booking status through the Vahak app. After booking a truck, you can check the trip details in your dashboard."
            },
            {
                question: "Why is “Lorry Market” empty?",
                response: `To see the available lorries, please select your routes (eg. Maharashtra, Rajasthan) from the ""Edit Profile"" section. Go to the updated  <a href='/marketplace/lorry'>“Lorry Market”</a> to see the available lorries. If it is still empty, then there are no available lorries in the market. You could try searching for lorries via the “Network” tab.`
            },
            {
                question: "How long does it take to book lorries on Vahak?",
                response:
                    "Vahak is a free <a href='/marketplace/load'>transportation marketplace of load</a> & truck owners and enquiries are usually closed in under 48 hours. Once you post your lorry/load requirement, you'll get bids within 20 minutes!"
            },
            {
                question: "What type of trucks do transporters own on Vahak?",
                response:
                    "<a href='/transporters'>Transport companies</a>, lorry owners and brokers have fleets including long haul vehicles like containers, full & half body trucks, and LCV. Hence, Vahak is the ideal platform for availing truck transportation services!"
            },
            {
                question: "How is Vahak helpful for a load owner?",
                response:
                    "Vahak helps load owners find trucks online easily. With this truck booking app, load owners can connect with a network of over 2,00,000+ transporters, find the best truck for their needs and successfully complete trips."
            },
            {
                question: "How will payments happen on Vahak?",
                response:
                    "Vahak connects load owners with lorry providers and the freight is calculated using rates exchanged and approved between two parties. Lorries are hired directly without any middlemen on the Vahak marketplace so the parties are liable to each other for the payments, safety & security of the consignments. Users can check out ratings, connections and recommendations for transporters & truck owners before making a decision."
            }
        ]
    },
    {
        category: FaqSlugsConstant.BOOKING_LOADS,
        faqQuestions: [
            {
                question: "How do I attach my lorry on Vahak?",
                subContent: [
                    "Open the Vahak app",
                    "Click on “Attach Lorry”",
                    "Enter your details and press “Attach Fleet”",
                    "Now your lorry will be visible to all transporters on Vahak!"
                ]
            },
            {
                question: "How do I book loads on Vahak?",
                response: `You can post your lorry details and get bids automatically from ${PLATFORM_STATS.transporters.lakhs} transporters. Or you can pick a load from the  <a href='/marketplace/load'>“Load Market”</a> directory. Follow these simple steps to find trucks:`,
                subContent: [
                    "Open the Vahak app",
                    "Go to the “Market” section",
                    "Click on <a href='/marketplace/load'> Load Market</a>",
                    "Browse through the available live loads",
                    "Press “Book Now”",
                    "Enter your Bid and send it across!"
                ]
            },
            {
                question: "What is the cost of booking loads on Vahak?",
                response:
                    "Vahak is completely free! There are no commissions, brokerage fees or hidden costs. It is India’s first fully free road transportation marketplace that lets users search lorries and loads online."
            },
            {
                question: "Can I track my truck's status?",
                response:
                    "Yes. You can track the status of your truck(s) on the Vahak app. After attaching your lorry you can see the trip details in your dashboard."
            },
            {
                question: "How do I grow my transport business on Vahak?",
                response:
                    "Transporters & truck owners can create business profiles and an online presence on the Vahak app. The business profile helps users attract business leads and connections which can be used for making deals. With branding features like Whatsapp Business Card, Branded enquiry cards that are sharable on Whatsapp, users can further promote their transport brand and online presence. If you are a truck driver looking for loads, Vahak is the best place to start!"
            },
            {
                question: "I am a lorry owner but don’t have a company, can I register on Vahak?",
                response:
                    "Yes, lorry owners & lorry brokers can register on Vahak as ‘Lorry Provider’. If users don't have a company, they can enter their own name and sign-up!"
            },
            {
                question: "How is Vahak helpful for me?",
                response: `With Vahak, anyone who owns a lorry can register and find business. On the Vahak app, users can find ${PLATFORM_STATS.liveLoadsAndLorries.label} loads for free. By attaching their truck with Vahak, they will be able to <a href='/online-load-booking'>find loads</a> and increase their revenue without any commissions!`
            },
            {
                question: "How will payments happen on Vahak?",
                response:
                    "Vahak connects lorry owners with load providers and the freight is calculated using rates exchanged and approved between two parties. Lorries are hired directly without any middlemen on <a href='/marketplace/lorry'> Vahak market </a> so the parties are liable to each other for the payments, safety & security of the consignments. Users can check out ratings, connections, recommendations for transporters & truck owners."
            }
        ]
    },
    {
        category: FaqSlugsConstant.GROWING_NETWORKS,
        faqQuestions: [
            {
                question: "How to connect with transporters on Vahak?",
                response:
                    "On the bottom right corner of the app, you will find the “Network” tab that shows you all the different logistics services providers in your city. You can add them using the “Connect” button."
            },
            {
                question: "What is the benefit of networking on Vahak?",
                response:
                    "You can connect with thousands of transporters on the Vahak app. Be it <a href='/online-truck-booking'>online truck booking </a>or <a href='/online-load-booking'>finding loads</a>, networking with these people will help you grow your business and increase your revenue."
            },
            {
                question: "Do I have to pay money to use this feature?",
                response:
                    "No! Vahak is a completely free platform where you can do everything from availing truck transportation services to <a href='/online-load-booking'>finding loads</a> online without any commissions. You can use the Network feature for free and grow your business by connecting with similar businesses."
            }
        ]
    },
    {
        category: FaqSlugsConstant.FRAUD_PREVENTION,
        faqQuestions: [
            {
                question: "Posing as Defence Personnel",
                response: ``,
                subContent: [
                    `Never entertain or deal with Vendors/Load Owners/Transporters posing as officials from Indian Defense as these are fraudsters. If you come across anyone with profile names like <i>Indian Army, Army, IATA, Indian Air Force, Air Force, India Navy Force, India Navy</i> or similar, please avoid dealing with them and inform Vahak Customer Support immediately.`,
                    `Never deal with people who pose as <i>Indian Army officials by showing Army ID Cards, Army Canteen Cards, Aadhaar Cards or any other Defense ID Card</i>. These ID cards are always fake as the Indian Army never posts load/lorry requirements publically.`,
                    `Never deal with people/load owners/transporters who quote load bid rates much higher than the market rate. Fraudsters generally quote un-common bid rates to lure transporters in the name of higher profits.`,
                    `Never deal with anyone who identifies themselves as Indian Army officials or Army Canteen officials and talk about providing quick and genuine payments. <u><strong>Indian Defense organisations never post any requirements publicly but instead do so through tenders and contracts.</strong></u>`,
                    `Being a lorry owner, never deal with parties who ask for advance/token payment in the form of <i>Army Registration Fees/Contract Service Fees/Contract Charges/Army Fees, etc</i>.<u><strong>A lorry owner does not need to pay any type of advance amount.</strong></u> If you are asked to pay the amount, refuse the deal and inform Vahak Customer Support about the same.`,
                    `When in a deal and asked about load pick-up from an Army Base or Airport, never confirm the deal and instead ask the party to share their Live Location on WhatsApp. Being a lorry owner, you can also request them for a token amount before going to the load pick-up location. Fraudsters generally provide genuine army load pick-up points to lure lorry owners.`,
                    `Never scan or click on any QR Code or UPI Payments Link to receive payment or make advance/token payment before making sure of the deal details. <u><strong>Being a lorry owner, you should never make any payment whatsoever through any source of any amount.</strong></u>`
                ]
            },
            {
                question: "UPI Payment Request/Fake QR Codes",
                response: ``,
                subContent: [
                    `Always remember to use <strong>Vahak Payments</strong> feature to make any sort of payments related to deals done on <strong>Vahak</strong> platform. This ensures that you avoid frauds/scams and can be helped out immediately if you face any issue.`,
                    `Never scan or click any QR Code or UPI Payments Link to make or receive payment. Being a load owner, you are not required to scan a QR code to create a payment account or make payments. Being a lorry owner, never scan any QR code or link to receive any payment as QR codes are never used to receive payment.`,
                    `<strong>Vahak</strong> or any genuine load owner would never ask you to share any OTP/PIN/ or any other Bank Details for confirming transactions or booking deals. Never share your bank details with anyone for doing any deal on Vahak.`,
                    `If you ever face any difficulty in using the <strong>Vahak Payments</strong> feature or come in contact with anyone who you think is a fraudster, please contact Vahak Customer Support immediately.`
                ]
            },
            {
                question: "Making Advance Payments/ Token Amount Payment",
                response: ``,
                subContent: [
                    `Either you are a load owner or a lorry owner, always use <strong>Vahak Payments</strong> feature to request or make an advance/token payment for a confirmed deal. These payments are stored safely with <strong>Vahak</strong> and can be tracked through the <strong>Vahak Payments</strong> feature.`,
                    `As a load owner, always request the lorry owner to come to the load pick-up location, if they have requested for an advance/token payment. In case you are sure of the deal and would like to make a token/advance payment, please ensure to use the Vahak Payments feature to avoid any frauds.`
                ]
            },
            {
                question: "Confirming a Deal",
                response: ``,
                subContent: [
                    `To confirm a deal on Vahak, either of the parties (load/lorry owner) needs to bid on <strong>Vahak</strong> marketplace on the respective load or lorry. Once the bid is confirmed, the parties can then communicate directly and negotiate on the total payment amount or the advance/token payment.`,
                    `Once finalized, ensure to accept or receive the total payment or the advance/token payment only through the <strong>Vahak Payments</strong> feature. This ensures that the parties have genuine transaction proofs and invoices for the completed deal and are safe from frauds.`,
                    `In case you have any query or need help in using the <strong>Vahak Payments</strong> feature, please contact the Vahak Customer Support for immediate assistance.`
                ]
            },
            {
                question: "Receiving/Making Payments on Vahak",
                response: ``,
                subContent: [
                    `When completing a deal on <strong>Vahak</strong>, <u>always ensure to make or receive total payment or advance/token payment only through the <strong>Vahak Payments</strong> feature.</u>`,
                    `If you are a load owner, pay the lorry owner some advance/token amount through the <strong>Vahak Payments</strong> feature to show your genuineness. The final payment of the due amount can be done afterwards also through <strong>Vahak Payments</strong>.`,
                    `If you are a lorry owner, request some advance/token amount from the load owner, if they ask you to visit the load pick-up location. This advance/token amount is stored safely with <strong>Vahak</strong> to avoid fraud load owners.`,
                    `Always remember these points when using the Vahak Payments feature: <br/>
                <span>1. <strong>Vahak Payments</strong> feature will be available only when a bid is accepted on <strong>Vahak</strong> marketplace.<br/>
                2. To begin, either the load owner or the lorry owner can then raise a request for advance payment, while the other has to approve. Amount negotiations can also be carried out during this time.<br/>
                3. After the advance payment is done, the amount paid by the load owner will be received by the lorry owner once the loading is completed. Till then, the payment is stored safely with <strong>Vahak</strong> so as to avoid frauds by either parties.<br/>
                4. In between this time, either party can raise a refund request if a legitimate issue arises.<br/>
                5. In case a refund request is raised, Vahak Customer Support team will call both the parties to know the exact issue and also collect the necessary documents/proofs.<br/>
                6. Refund requests will be accepted or rejected based on the document proofs provided by the parties.<br/>
                7. The total amount to be paid on completion of the deal can also be paid in installments as per the mutual agreement between the parties.</span>`
                ]
            }
        ]
    },
    {
        category: FaqSlugsConstant.LOGISTICS_SERVICES,
        faqQuestions: [
            {
                question: "How do I book logistics services on Vahak?",
                response: "To book logistics services on Vahak,",
                subContent: [
                    `Go to our website, www.vahak.in`,
                    `Register & verify yourself if you do not have an account by providing basic ID details.`,
                    `Now, attach your load, by providing basic details about your load.`,
                    `Once done, go to the "Logistics Services" section by clicking on the "Services" tab.`,
                    `On the "Logistics Services" page, click on the "Book Logistics Services" button.`,
                    `You will be now re-directed to the Live Marketplace based on your default source location.`,
                    `Now, search, verify & select the best possible deal by choosing trucks from ${PLATFORM_STATS.transporters.lakhsLong} logistics service providers.`,
                    `You can bid on the listed trucks according to your need & connect with them directly to confirm the booking.`
                ]
            },
            {
                question: "What is the cost of booking logistics services on Vahak?",
                response:
                    "Vahak is completely FREE to use for any user. We do not charge any commission fees or any other hidden charges to use our platform. We are India's one & only free online transport marketplace to book loads or lorries."
            },
            {
                question: "How do I attach my loads on Vahak to book logistics services?",
                response: "To attach loads on Vahak,",
                subContent: [
                    `Go to our website, www.vahak.in`,
                    `Register & verify yourself if you do not have an account by providing basic ID details.`,
                    `Next go to the "My Loads" tab & click on "Post Load".`,
                    `Now, provide complete details about your load, destination city & truck type required. Also provide any ODC remarks if necessary.`,
                    `Once done, your load will become live on the "Load Marketplace" where users will be able to view your load and bid on it.`
                ]
            },
            {
                question: "Can I track my logistics services booking status?",
                response: `Yes, you can track your logistics services booking status easily through your user profile dashboard on the Vahak wesbsite. Once you book a logistic service, your booking details will be made available under the "Trip Details" dashboard.`
            },
            {
                question: "How do I make the payments for my logistics services booking?",
                response: `Once your booking is complete you can use the "Vahak Payments" feature to make payments for your booking. "Vahak Payments" is our own 100% safe & secure payment gateway that allows you to make hassle-free & secure payments through various payment modes like UPI, Bank Account, and Debit Card. After the booking is confirmed, use the "Vahak Payments" to make the advance payment decided mutually between you and the service provider. Once the booking is completed and you have received the Proof of Delivery (PoD) receipt from the service provider, pay the remaining amount also through the "Vahak Payments" feature.`
            }
        ]
    }
];
